import { CoreMenu } from 'src/@core/types';

export const tasksMenu: CoreMenu[] = [
  {
    id: 'Tasks',
    title: 'Tasks',
    type: 'collapsible',
    icon: 'task.svg',
    role: {
      roles: ['employee'],
      right: ['H1008', 'H1025', 'H1023'],
    },
    children: [
      {
        id: 'tasks',
        title: 'Tasks',
        type: 'item',
        icon: 'task.svg',
        url: '/i-team/tasks',
        exactMatch: true,
        role: {
          roles: ['employee'],
          right: 'H1025',
        },
      },
      {
        id: 'backlogs',
        title: 'Unassigned Backlogs',
        type: 'item',
        icon: 'backlog.svg',
        url: '/i-team/unassigned-backlogs',
        exactMatch: true,
        role: {
          roles: ['employee'],
          right: 'H1543',
        },
      },
      {
        id: 'pending-tasks',
        title: 'Missed Deadlines',
        type: 'item',
        icon: 'missed-deadline.svg',
        url: '/i-team/missed-deadlines',
        exactMatch: true,
        role: {
          roles: ['employee'],
          right: 'H1742',
        },
      },
      {
        id: 'Task-Summary',
        title: 'Task Summary',
        type: 'item',
        icon: 'task.svg',
        url: '/i-team/tasks/summary',
        role: {
          roles: ['employee'],
          right: 'H1023',
        },
      },
      {
        id: 'Daily-Reports',
        title: 'Daily Reports',
        type: 'item',
        icon: 'daily-report.svg',
        url: '/i-team/tasks/daily-reports',
        role: {
          roles: ['employee'],
          right: 'H1545',
        },
      },


    ],
  },
];
